import { Col, Layout, Row, Spin, Table, Tag } from "antd";
import axios from "axios";
import React, { Component } from "react";
import Moment from "react-moment";
import { connect } from "react-redux";
import { Constant } from "../../config";
import { GatewayColor, GatewayName } from "../../config/gateway";
import "../../index.css";
import { fetchMenuAction } from "../../store/actions/leftSideMenu";
import SearchForm from "./search-form";
import { checkRolePermission } from "../../services/permission";
import { permissionName, permissionType } from "../../config/permission";

const { Content } = Layout;
const CAMPAIGN = "campaign";
const API = "api";

Moment.globalLocal = false;

const getStatusTags = (status) => {
  if (status === "S") return <Tag color="cyan">Sent</Tag>;
  else if (status === "RECVD") return <Tag color="blue">Received</Tag>;
  else if (status === "FG") return <Tag color="red">Fail Gateway</Tag>;
  else if (status === "FO") return <Tag color="red">Fail Operator</Tag>;
  else if (status === "A") return <Tag color="purple">Not-Received-A</Tag>;
  else if (status === "FM")
    return (
      <Tag
        color="#CCD5DB"
        style={{ color: "#526069", border: "1px solid #526069" }}
      >
        Not Received-M
      </Tag>
    );
  else if (status === "B")
    return (
      <Tag
        color="#CCD5DB"
        style={{ color: "#526069", border: "1px solid #526069" }}
      >
        Blacklist
      </Tag>
    );

  // INPR, E
  return <Tag>{status}</Tag>;
};

const getCallbackMethodTag = (method) => {
  let color = "";

  if (method === "POST") color = "orange";
  else if (method === "GET") color = "green";
  else if (method === "PUT") color = "blue";
  else if (method === "DELETE") color = "red";

  return (
    <Tag style={{ marginBottom: "8px" }} color={color}>
      {method}
    </Tag>
  );
};

class SmsLogs extends Component {
  state = {
    loading: false,

    countryList: [],
    currentCountryAbbr: "",
    currentGatewayID: 0,
    currentPage: 1,
    currentSearch: "",
    currentSlType: CAMPAIGN,
    currentStatus: "",

    dataSource: [],
    gatewayList: [],
    totalRows: 0,
  };

  columns = [
    {
      align: "center",
      dataIndex: "sent_date",
      render: (sentDate) => {
        if (!sentDate) return "-";

        return (
          <Moment tz="Etc/UTC" format="MMM DD YYYY HH:mm">
            {sentDate}
          </Moment>
        );
      },
      title: "Sent Date / Time",
      width: "150px",
    },
    {
      align: "center",
      dataIndex: "member_email",
      title: "Email",
      width: "150px",
    },
    {
      align: "center",
      dataIndex: "msisdn",
      render: (msisdn, record) => {
        return (
          <span>
            <span>{msisdn}</span>
            <br />
            <Tag color="brown">{record.receiver_country || "-"}</Tag>
          </span>
        );
      },
      title: "Phone No.",
      width: "150px",
    },
    {
      dataIndex: "message",
      render: (message, record) => {
        return (
          <div style={{ maxWidth: "400px", overflowWrap: "break-word" }}>
            <span>{message}</span>
            <br />
            <Tag color="orange">Sender: {record.sender_name || "-"}</Tag>
            <Tag color="red" style={{ marginBottom: "8px" }}>
              Total SMS: {record.total_sms || "-"}
            </Tag>
            <br />
            <Tag color="blue">Message ID: {record.smid || "-"}</Tag>
          </div>
        );
      },
      title: "Message",
      width: "400px",
    },
    {
      align: "center",
      dataIndex: "status",
      render: (status) => getStatusTags(status),
      title: "Status",
      width: "100px",
    },
    {
      dataIndex: "gateway_name",
      render: (gatewayName, record) => {
        let gatewayDrStatus = "-";
        let gatewayDrStatusDescription = "-";
        if (record.gateway_dr_status_detail) {
          gatewayDrStatus = `${
            record.gateway_dr_status_detail.raw_status_group || "-"
          } | ${record.gateway_dr_status_detail.raw_status || "-"}`;
          gatewayDrStatusDescription =
            record.gateway_dr_status_detail.description || "-";
        }

        return (
          <span>
            <Tag
              color={GatewayColor(gatewayName)}
              style={{ marginBottom: "8px" }}
            >
              {GatewayName(gatewayName)}
            </Tag>
            <span>{record.gateway_smid || "-"}</span>
            <br />
            <Tag style={{ marginBottom: "8px" }}>{gatewayDrStatus}</Tag>
            <span>{gatewayDrStatusDescription}</span>
            <br />
          </span>
        );
      },
      title: "Gateway",
      width: "500px",
    },
    {
      align: "center",
      dataIndex: "ack_date",
      render: (ackDate) => {
        if (!ackDate) return "-";

        return (
          <Moment tz="Etc/UTC" format="MMM DD YYYY HH:mm">
            {ackDate}
          </Moment>
        );
      },
      title: "DR Date / Time",
      width: "150px",
    },
    {
      align: "center",
      dataIndex: "sl_price_detail.client_rate",
      render: (clientRate) => {
        return clientRate || "-";
      },
      title: "Client Rate",
      width: "100px",
    },
  ];

  marketRateCol = {
    align: "center",
    dataIndex: "sl_price_detail.market_rate",
    render: (marketRate) => {
      return marketRate || "-";
    },
    title: "Market Rate",
    width: "100px",
  };

  gatewayRateCol = {
    align: "center",
    dataIndex: "sl_price_detail.gateway_rate",
    render: (gatewayRate, record) => {
      if (gatewayRate <= 0) return "-";

      let currency = "-";

      if (record.sl_price_detail)
        currency = record.sl_price_detail.gateway_rate_currency || "-";

      return (
        <span>
          <span>{gatewayRate || "-"}</span>
          <br />
          <Tag color="brown" style={{ marginRight: "0px" }}>
            {currency}
          </Tag>
        </span>
      );
    },
    title: "Gateway Rate",
    width: "120px",
  };

  notifyUserCol = {
    dataIndex: "notify_date",
    render: (notifyDate, record) => {
      if (!notifyDate) return "-";

      return (
        <span>
          {getCallbackMethodTag(record.callback_method || "")}
          <span>{record.callback_url || "-"}</span>
          <br />
          <Moment tz="Etc/UTC" format="MMM DD YYYY HH:mm">
            {notifyDate}
          </Moment>
        </span>
      );
    },
    title: "Notify to user",
    width: "500px",
  };
  limit = 20;

  componentWillMount() {
    this.props.fetchMenuAction("sms-logs", "outbound-v2");
    this.setState({ loading: true });
    const canReadMarketRate = checkRolePermission(
      permissionName.SMS_LOG,
      permissionType.READ_MARKET_RATE
    );
    const canReadGatewayRate = checkRolePermission(
      permissionName.SMS_LOG,
      permissionType.READ_GATEWAY_RATE
    );
    const canReadNotifyUser = checkRolePermission(
      permissionName.SMS_LOG,
      permissionType.READ_NOTIFY_USER
    );
    if (canReadMarketRate) {
      this.columns.push(this.marketRateCol);
    }
    if (canReadGatewayRate) {
      this.columns.push(this.gatewayRateCol);
    }
    if (canReadNotifyUser) {
      this.columns.push(this.notifyUserCol);
    }
  }

  async componentDidMount() {
    this.setState({
      countryList: await this.getCountryList(),
      gatewayList: await this.getGatewayList(),
      loading: false,
    });
  }

  changePage = async (page) => {
    this.setState({
      currentPage: page,
      loading: true,
    });

    await this.getDataList(
      page,
      this.state.currentSearch,
      this.state.currentCountryAbbr,
      this.state.currentGatewayID,
      this.state.currentSlType
    );

    this.setState({ loading: false });
  };

  getCountryList = async () => {
    const opt = {
      url: `${Constant.COUNTRY_API}?limit=0`,
      method: "GET",
      headers: {
        Authorization: "Bearer " + localStorage.getItem(Constant.SessionKey),
      },
    };
    let resp;

    try {
      resp = await axios(opt);
    } catch (err) {
      resp = err.response;
    }

    if (!resp.data) {
      console.log(resp.data);
      return [];
    }

    if (resp.data.error) {
      console.log(resp.data.error);
      return [];
    }

    this.setState({ countryListForrm: resp.data.data });

    let rtn = [{ region_code: "", name: "ทั้งหมด" }];
    resp.data.data.map((v) => rtn.push(v));

    return rtn;
  };

  getDataList = async (
    page = 1,
    search = "",
    country_abbr = "",
    gateway_id = 0,
    currentSlType = "",
    status = ""
  ) => {
    let url = "";
    if (currentSlType === CAMPAIGN) url = Constant.SL_CAMPAIGN;
    else if (currentSlType === API) url = Constant.SL_API;
    else return;

    let resp;
    const token = localStorage.getItem(Constant.SessionKey);
    const opt = {
      headers: { Authorization: `Bearer ${token}` },
      method: "GET",
      params: {
        page,
        limit: this.limit,
        search,
        receiver_country: country_abbr,
        gateway_id,
        order: "desc",
        status: status,
      },
      url,
    };

    try {
      resp = await axios(opt);

      if (!resp.data) throw new Error("Response key 'data' is undefined.");
    } catch (e) {
      console.error(e);
      return;
    }

    this.setState({
      currentPage: resp.data.page || 1,
      dataSource: resp.data.data || [],
      loading: false,
      totalRows: resp.data.total_rows || 0,
    });
  };

  getGatewayList = async () => {
    const opt = {
      url: `${Constant.GATEWAY_API}?limit=0`,
      method: "GET",
      headers: {
        Authorization: "Bearer " + localStorage.getItem(Constant.SessionKey),
      },
    };
    let resp;

    try {
      resp = await axios(opt);
    } catch (err) {
      resp = err.response;
    }

    if (!resp.data) {
      console.log(resp.data);
      return [];
    }

    if (resp.data.error) {
      console.log(resp.data.error);
      return [];
    }

    this.setState({ gatewayListForm: resp.data.data });

    let rtn = [{ id: 0, name: "ทั้งหมด" }];
    resp.data.data.map((v) => rtn.push(v));

    return rtn;
  };

  mySearch = (fd) => {
    fd.validateFields(async (err, values) => {
      if (err) return;

      const currentCountryAbbr = values.country_abbr || "";
      const currentGatewayID = values.gateway_id || 0;
      const currentPage = 1;
      let currentSearch = values.searchTxt || "";
      const currentSlType = values.sl_type || CAMPAIGN;
      const currentStatus = values.status || "";

      //make wavecell to lowercase
      const gatewayLowerCase = [6, 8, 9, 10];
      if (gatewayLowerCase.includes(currentGatewayID)) {
        currentSearch = currentSearch.toLowerCase();
      }

      this.setState({
        currentCountryAbbr,
        currentGatewayID,
        currentPage,
        currentSearch,
        currentSlType,
        currentStatus,
        loading: true,
      });

      await this.getDataList(
        currentPage,
        currentSearch,
        currentCountryAbbr,
        currentGatewayID,
        currentSlType,
        currentStatus
      );

      this.setState({ loading: false });
    });
  };

  resetSearch = async () => {
    this.setState({
      currentCountryAbbr: undefined,
      currentGatewayID: undefined,
      currentPage: 1,
      currentSearch: undefined,
      currentSlType: CAMPAIGN,
      dataSource: [],
      loading: false,
      totalRows: 0,
    });
  };

  render() {
    const propsTable = {
      bordered: true,
      className: "my-table",
      columns: this.columns,
      dataSource: this.state.dataSource,
      rowKey: "id",
      pagination: {
        pageSize: this.limit,
        total: this.state.totalRows,
        current: this.state.currentPage,
        onChange: this.changePage,
        size: "small",
      },
      size: "small",
      scroll: {
        x: 1500,
      },
    };

    return (
      <Layout className="my-layout">
        <Spin spinning={this.state.loading} tip="กำลังโหลดข้อมูล...">
          <Content
            style={{
              background: "#fff",
              padding: 24,
              margin: "16px 0",
              minHeight: 300,
            }}
          >
            <h2>SMS Logs</h2>
            <p className="header-desc">
              บันทึกรายการ Outbound SMS (console version 2) (เฉพาะ 120 วัน
              ล่าสุด)
            </p>
            <Row className="utility-bar">
              <Col span={24}>
                <SearchForm
                  countryList={this.state.countryList}
                  gatewayList={this.state.gatewayList}
                  fn={this.mySearch}
                  fnReset={this.resetSearch}
                  table={"sms"}
                />
              </Col>
            </Row>
            <Row className="utility-bar-mobile">
              <SearchForm
                countryList={this.state.countryList}
                gatewayList={this.state.gatewayList}
                fn={this.mySearch}
                fnReset={this.resetSearch}
                table={"sms"}
              />
            </Row>
            <Table {...propsTable} />
            <div className="mt-2 tag-info">
              <div className="tag-info-container">
                <Tag>In-progress</Tag> <div>Sending to operator</div>
              </div>
              <div className="tag-info-container">
                <Tag color="cyan">Sent</Tag> <div>Sent to operator</div>
              </div>
              <div className="tag-info-container">
                <Tag color="blue">Received</Tag>{" "}
                <div>Recipients received messages</div>
              </div>
              <div className="tag-info-container">
                <Tag color="red">Fail Operator</Tag>{" "}
                <div>Operator cannot sent SMS to recipients</div>
              </div>
              <div className="tag-info-container">
                <Tag color="red">Fail Gateway</Tag>{" "}
                <div>Cannot send SMS to operator</div>
              </div>
              <div className="tag-info-container">
                <Tag color="purple">Not-Received-A</Tag>{" "}
                <div>
                  Recipients didn't receive messages as they informed Oper of
                  not receiving SMS or ads. (Anti-Spam)
                </div>
              </div>
              <div className="tag-info-container">
                <Tag
                  color="#CCD5DB"
                  style={{ color: "#526069", border: "1px solid #526069" }}
                >
                  Not Received-M
                </Tag>
                <div>
                  Recipients didn't receive messages because of mobile phone
                  problems. (no signal or insufficient storage)
                </div>
              </div>
              <div className="tag-info-container">
                <Tag
                  color="#CCD5DB"
                  style={{ color: "#526069", border: "1px solid #526069" }}
                >
                  Blacklist
                </Tag>
                <div>Recipient informed to not received messages.</div>
              </div>
            </div>
          </Content>
        </Spin>
      </Layout>
    );
  }
}

const mapDispatchToProps = (dispatch) => {
  return {
    fetchMenuAction: (menuParentKey, menuKey) =>
      dispatch(fetchMenuAction(menuParentKey, menuKey)),
  };
};

export default connect(null, mapDispatchToProps)(SmsLogs);



// WEBPACK FOOTER //
// ./src/containers/SmsLogs/index.js